<div *ngIf="!isLoading && !isError">
    <mat-toolbar class="bar-filler"></mat-toolbar>
    <div style="height: 10px;"></div>
    <mat-card class="small-margin disable-select">
        <mat-card-header>
            <mat-card-title>{{'Pages.OrderResume.Info.DataTitle' | translate}}</mat-card-title>
        </mat-card-header>
        <div *ngIf="orderMode !== 0">
            <mat-card-content>{{'Pages.OrderResume.Info.Name' | translate}} {{fullName}}</mat-card-content>
            <mat-card-content>{{'Pages.OrderResume.Info.Phone' | translate}} {{phone}}</mat-card-content>
        </div>
        <mat-card-content *ngIf="orderMode === 0">{{payCardString}}</mat-card-content>
        <mat-card-content>{{'Pages.OrderResume.Info.Mode' | translate}} {{orderModeString}}</mat-card-content>
        <mat-card-content *ngIf="baseData?.scheduled === true">{{'Pages.OrderResume.Info.ScheduledFor' | translate}} {{baseData.scheduledfor}}.</mat-card-content>
        <mat-card-content *ngIf="orderMode === 2 || orderMode === 4">
            <div *ngIf="baseData.paymode === 0 ">
                <p>{{'Pages.OrderResume.Info.Payment.Cash' | translate}}</p>
                <p *ngIf="baseData.needschange === 0">{{'Pages.OrderResume.Info.Payment.NoChange' | translate}}</p>
                <p *ngIf="baseData.needschange === 1" >{{'Pages.OrderResume.Info.Payment.ChangeFor' | translate}} {{changeString}}</p>
            </div>
            <p *ngIf="baseData.paymode === 1">{{'Pages.OrderResume.Info.Payment.Card' | translate}}</p>
        </mat-card-content>
        <mat-card-content *ngIf="orderMode === 4">{{'Pages.OrderResume.Info.Reference' | translate}} {{carDescription.Model}} {{carDescription.Color}} - {{carDescription.Reference}}</mat-card-content>
        <mat-card-content >{{'Pages.OrderResume.Info.WaitTime' | translate}} {{waitTimeString}}</mat-card-content> 
        <mat-card-content *ngIf="coupon !== undefined && coupon !== null">{{'Pages.OrderResume.Info.Coupon' | translate}}: {{coupon?.Name}}</mat-card-content>
    </mat-card>
    <div *ngIf="orderMode === 2">
        <div style="height: 10px;"></div>
        <mat-card class="small-margin disable-select">
            <mat-card-header>
                <mat-card-title>{{'Pages.OrderResume.Info.Adress' | translate}}</mat-card-title>
            </mat-card-header>
            <mat-card-content *ngIf="orderMode === 2"> 
                <p>{{adress?.FullAdress}}</p>
                <mat-card-actions>
                    <button class="fill-parent-width" mat-stroked-button (click)="changeAdress()">{{'Pages.OrderResume.Info.ChangeAdress' | translate}}</button>
                </mat-card-actions>
            </mat-card-content>
        </mat-card>
    </div>
    <div style="height: 20px;"></div>
    <div class="small-margin">
        <div class="floating-text bold">{{'Pages.OrderResume.OrderItens' | translate}}</div>
        <mat-divider></mat-divider>
    </div>
    <div *ngFor="let item of itemList" class="flex-container-center">
        <div class="small-margin">
            <div>
                <div class="flex-container-center">
                    <div class="label">{{item.Name}}</div>
                    <div class="small-detail small-margin">{{item.WaitTime}}</div>
                </div>
                <div class="detail summary-text">{{item.Description}}</div>
            </div>
        </div>
        <div class="float-right price-label small-margin">{{item.PriceString}}</div>
        <mat-divider></mat-divider>
    </div>
    <div *ngIf="coupon !== undefined && coupon !== null" class="flex-container-center">
        <div>
            <div class="label small-margin">{{coupon.Name}}</div>
            <div class="detail small-margin">{{coupon.ValueString}}</div>
        </div>
        <div class="float-right price-label small-margin">{{coupon.FinalValueString}}</div>
        <mat-divider></mat-divider>
    </div>
    <div *ngIf="hasFee === true" class="flex-container-center">
        <div class="label small-margin">{{'Pages.OrderResume.DeliveryFee' | translate}}</div>
        <div class="float-right price-label small-margin">{{feeString}}</div>
        <mat-divider></mat-divider>
    </div>
    <mat-toolbar class="bar-filler">
        <mat-toolbar-row>
            <P></P>
        </mat-toolbar-row>
        <mat-toolbar-row>
            <P></P>
        </mat-toolbar-row>
    </mat-toolbar>
    <mat-toolbar color="primary" class="top-bar">
        <button mat-icon-button (click)="back()">
            <mat-icon>arrow_back</mat-icon>
        </button>
        <div>{{'Pages.OrderResume.Title' | translate}}</div>
    </mat-toolbar>
    <mat-toolbar class="bottom-bar" color="primary">
        <mat-toolbar-row>
            <div class="big-price-text">{{currentPriceString}}</div>
        </mat-toolbar-row>
        <mat-toolbar-row>
            <button mat-flat-button color="accent" disabled="{{!hasItem}}" (click)="sendOrder()" class="fill-parent-width">{{'Pages.OrderResume.Send' | translate}}</button>
        </mat-toolbar-row>
    </mat-toolbar>
</div>
<div *ngIf="isLoading && !isError" class="floating-container">
    <mat-spinner></mat-spinner>
    <p class="floating-label">{{'Pages.OrderResume.Sending' | translate}}</p>
</div>
<div *ngIf="isError" class="floating-container">
    <mat-card>
        <mat-card-header>
            <mat-card-title>{{'Errors.ConectionError.Title' | translate}}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <p>{{'Errors.ConectionError.Message' | translate}}</p>
          </mat-card-content>
          <mat-card-actions>
            <button mat-raised-button color="accent" class="fill-parent-width" (click)="tryAgain()">{{'Errors.ConectionError.Button' | translate}}</button>
          </mat-card-actions>
    </mat-card>
</div>